import styled, { createGlobalStyle } from "styled-components"

export const TeamPerformanceGlobalStyle = createGlobalStyle`
  @media (min-width: 768px) {
    main {
      max-width: 90% !important;
      margin: 0 auto;
    }
  }
`

export const OverlayProgress = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;

  .progress-box {
    background: white;
    padding: 30px 40px;
    border-radius: 12px;
    text-align: center;
    color: #333;
    box-shadow: 0 4px 15px rgba(0,0,0,0.2);

    h3 {
      margin: 0 0 15px 0;
      color: #0b3c84;
    }

    .progress-bar-container {
      width: 300px;
      height: 10px;
      background: #e2e3e5;
      border-radius: 5px;
      overflow: hidden;
      margin: 0 auto 10px auto;

      .progress-bar-fill {
        height: 100%;
        background: #28a745;
        transition: width 0.3s ease;
      }
    }
    
    .progress-text {
      font-weight: bold;
      font-size: 16px;
      color: #555;
    }
  }
`

export const TeamPerformanceContainer = styled.div`
  padding: 20px;
  min-height: 100vh;
  font-family: 'Open Sans', 'Helvetica Neue', Arial, sans-serif;

  .header-title {
    color: #0b3c84;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
  }
`

export const FilterSection = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  flex-wrap: wrap;
  gap: 20px;

  .filter-group {
    display: flex;
    gap: 20px;
    align-items: flex-end;
    flex-wrap: wrap;

    .filter-item {
      display: flex;
      flex-direction: column;

      label {
        font-size: 12px;
        color: #555;
        font-weight: 600;
        margin-bottom: 8px;
      }

      select, input[type="date"] {
        padding: 8px 12px;
        border: 1px solid #ddd;
        border-radius: 4px;
        outline: none;
        font-size: 14px;
        min-width: 150px;
        color: #333;
        height: 38px;
        box-sizing: border-box;
      }
    }

    .btn-apply {
      background-color: #0b3c84;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 4px;
      font-weight: 600;
      cursor: pointer;
      font-size: 14px;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  .btn-download {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
    font-size: 14px;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;

    .filter-group {
      flex-direction: column;
      align-items: stretch;
      width: 100%;

      .filter-item {
        width: 100%;
        select, input[type="date"] {
          width: 100%;
        }
      }

      .btn-apply {
        width: 100%;
      }
    }

    .btn-download {
      width: 100%;
    }
  }
`

export const KPICardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const KPICard = styled.div<{ borderColor: string }>`
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  border-top: 4px solid ${(props) => props.borderColor};
  display: flex;
  flex-direction: column;
  justify-content: center;

  .kpi-title {
    font-size: 12px;
    color: #666;
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .kpi-value {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 5px;
    
    &.red-text { color: #d32f2f; }
    &.green-text { color: #28a745; }
    &.default-text { color: #333; }
  }

  .kpi-subtitle {
    font-size: 12px;
    color: #888;
  }
`

export const TableSection = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);

  .table-header {
    margin-bottom: 20px;
    
    .table-title {
      font-size: 18px;
      font-weight: 700;
      color: #333;
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 5px;

      .badge {
        background-color: #d32f2f;
        color: white;
        font-size: 12px;
        padding: 4px 10px;
        border-radius: 20px;
      }
    }

    .table-subtitle {
      font-size: 12px;
      color: #666;
    }
  }

  .table-responsive {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;

    th {
      font-size: 12px;
      font-weight: 700;
      color: #333;
      padding: 12px;
      border-bottom: 2px solid #f0f0f0;
      background-color: #f9f9f9;
    }

    td {
      padding: 12px;
      font-size: 13px;
      color: #444;
      border-bottom: 1px solid #f0f0f0;
      vertical-align: middle;

      a {
        color: #0b3c84;
        text-decoration: none;
        font-weight: 400;
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
`

export const StatusPill = styled.span<{ bgColor: string, textColor: string }>`
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.textColor};
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  display: inline-block;
  min-width: 110px;
  text-align: center;
`
